import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useCallback } from 'react';
import { useCombobox } from 'downshift';
import { useToken } from '@rexlabs/styling';
import Icons from '@rexlabs/icons';
import { Breakpoints } from '@rexlabs/breakpoints';
import { OverlayActionMenu } from './overlay';
import { FloatingActionMenu } from './floating';
import { isRegularAcctionMenuItem, isCustomElementActionMenuItem } from '../types';
var Ellipsis = Icons.Ellipsis;
var displayName = 'ActionMenu';

function stateReducer(_, _ref) {
  var type = _ref.type,
      changes = _ref.changes;

  if (type === useCombobox.stateChangeTypes.ItemClick || type === useCombobox.stateChangeTypes.InputKeyDownEnter || type === useCombobox.stateChangeTypes.FunctionSelectItem) {
    var selectedItem = changes.selectedItem;

    if (selectedItem !== null && selectedItem !== void 0 && selectedItem.hasOwnProperty('items')) {
      return _objectSpread(_objectSpread({}, changes), {}, {
        isOpen: true
      });
    } else {
      return _objectSpread(_objectSpread({}, changes), {}, {
        selectedItem: null
      });
    }
  }

  return changes;
}
/**
 * Action Menus display a list of actions or options that a user can choose.
 */


export function ActionMenu(_ref2) {
  var items = _ref2.items,
      title = _ref2.title,
      minWidth = _ref2.minWidth,
      maxWidth = _ref2.maxWidth,
      placement = _ref2.placement,
      portalTarget = _ref2.portalTarget,
      IconProp = _ref2.Icon,
      Button = _ref2.Button,
      TitleIcon = _ref2.TitleIcon,
      CloseButton = _ref2.CloseButton;
  var token = useToken();

  var _useCombobox = useCombobox({
    items: items,
    stateReducer: stateReducer
  }),
      isOpen = _useCombobox.isOpen,
      selectedItem = _useCombobox.selectedItem,
      highlightedIndex = _useCombobox.highlightedIndex,
      closeMenu = _useCombobox.closeMenu,
      selectItem = _useCombobox.selectItem,
      getItemProps = _useCombobox.getItemProps,
      getMenuProps = _useCombobox.getMenuProps,
      getInputProps = _useCombobox.getInputProps,
      getToggleButtonProps = _useCombobox.getToggleButtonProps,
      getComboboxProps = _useCombobox.getComboboxProps;

  var Icon = IconProp !== null && IconProp !== void 0 ? IconProp : token('actionMenu.button.icon.svg', Ellipsis); // We don't need these elements but we still want to use the keyboard
  // navigation and stop downshift from complaining

  var _getInputProps = getInputProps({}, {
    suppressRefError: true
  }),
      onKeyDown = _getInputProps.onKeyDown;

  getComboboxProps({}, {
    suppressRefError: true
  });
  var handleClose = useCallback(function () {
    closeMenu();
    selectItem(null);
  }, [closeMenu, selectItem]);
  var subItems = isCustomElementActionMenuItem(selectedItem) || isRegularAcctionMenuItem(selectedItem) ? selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.items : null;
  var props = {
    // Custom props
    items: items,
    subItems: subItems,
    title: title,
    minWidth: minWidth,
    maxWidth: maxWidth,
    placement: placement,
    portalTarget: portalTarget,
    handleClose: handleClose,
    Icon: Icon,
    Button: Button,
    TitleIcon: TitleIcon,
    CloseButton: CloseButton,
    // Downshift props
    isOpen: isOpen,
    selectedItem: selectedItem,
    highlightedIndex: highlightedIndex,
    selectItem: selectItem,
    getItemProps: getItemProps,
    getMenuProps: getMenuProps,
    getToggleButtonProps: getToggleButtonProps,
    onKeyDown: onKeyDown
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      maxWidth: token('actionMenu.breakpoint', 's')
    }
  }, /*#__PURE__*/React.createElement(OverlayActionMenu, props)), /*#__PURE__*/React.createElement(Breakpoints, {
    queries: {
      minWidth: token('actionMenu.breakpoint', 's')
    }
  }, /*#__PURE__*/React.createElement(FloatingActionMenu, props)));
}
ActionMenu.displayName = displayName;
export default ActionMenu;